<template>
  <v-dialog width="600" v-model="dialog">
    <v-card>
      <gg-toolbar @close="close">
        Delete redirect
      </gg-toolbar>
      <v-card-text v-if="redirect">
        Are you certain that you wish to <b>permanently</b> remove the redirect “{{ redirect.source }}” on
        “{{ redirect.domain }}”?
      </v-card-text>
      <v-card-actions class="justify-end">
        <gg-btn secondary @click="close">
          Close
        </gg-btn>
        <gg-btn :loading="loading" @click="deleteRedirect">
          Remove Redirect
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'DeleteRedirectModal',
  mixins: [modalMixin],
  props: {
    redirect: {
      required: true,
      validator (val) {
        return val === null || typeof val === 'object'
      }
    }
  },
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions(['cpanel_uapi', 'reportError', 'reportSuccess']),
    async deleteRedirect () {
      this.loading = true
      const data = {
        uapi_module: 'Mime',
        uapi_function: 'delete_redirect',
        domain: this.redirect.domain,
        redirect: this.redirect.redirect,
        docroot: this.redirect.docroot,
        src: this.redirect.source,
        _username: this.$route.query.user,
      }
      try {
        await this.cpanel_uapi(data)
        this.reportSuccess('The redirect has been removed.')
        this.loading = false
        this.$emit('redirect-deleted')
        this.close()
      } catch (e) {
        this.loading = true
        this.reportError(e.resultmsg)
      }
    }
  },
}
</script>
